export const ServiceUrls = {
    IDP_SERVICE: "https://idp-service",
    CUS_SERVICE: "https://backend-cus",
    CREATE_LEAD: "https://www.careers360.com",
    COMMON_IDP_POST: "https://www.careers360.de"
};
  